import { render, staticRenderFns } from "./button.vue?vue&type=template&id=5e228f0d"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e228f0d')) {
      api.createRecord('5e228f0d', component.options)
    } else {
      api.reload('5e228f0d', component.options)
    }
    module.hot.accept("./button.vue?vue&type=template&id=5e228f0d", function () {
      api.rerender('5e228f0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/message-control/button.vue"
export default component.exports